import React from 'react'

const icon = ({ className, fill = 'black', onClick }) => 
(
    <svg className={className} fill={fill} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" >
  <path d="M16.293 9.79398L17.707 11.208L12 16.915L6.29303 11.208L7.70703 9.79398L11 13.087V2.50098H13V13.087L16.293 9.79398Z" fill="#363636"/>
  <path d="M18 20.501V18.501H20V20.501C20 21.603 19.104 22.501 18 22.501H6C4.896 22.501 4 21.603 4 20.501V18.501H6V20.501H18Z" fill="#363636"/>
</svg>
)
export default icon
